import { render, staticRenderFns } from "./RegisterButton.html?vue&type=template&id=6730df19&scoped=true&"
import script from "./RegisterButton.js?vue&type=script&lang=js&"
export * from "./RegisterButton.js?vue&type=script&lang=js&"
import style0 from "./RegisterButton.scss?vue&type=style&index=0&id=6730df19&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6730df19",
  null
  
)

export default component.exports